
import { Navigation } from "swiper";
import ShopByOfferTile from "./ShopByOfferTile";

export default {
  name: "ShopByOffer",

  components: { ShopByOfferTile },

  props: {
    slice: { type: Object, required: true },
  },

  data() {
    return {
      swiperClass: "shop-by-offer-swiper",
    };
  },

  computed: {
    swiperOptions() {
      return {
        slidesPerView: "auto",
        spaceBetween: 12,
        slidesPerGroup: 2,

        breakpoints: {
          768: {
            slidesPerGroup: 4,
          },
        },

        modules: [Navigation],

        navigation: {
          nextEl: `.${this.swiperClass}-next`,
          prevEl: `.${this.swiperClass}-prev`,
        },
      };
    },

    displayCarousel() {
      return this.slice?.primary?.list_type;
    },
  },

  async mounted() {
    if (this.displayCarousel) {
      await this.$swiper.init(
        `.swiper.${this.swiperClass}`,
        this.swiperOptions
      );
    }
  },

  destroyed() {
    if (this.displayCarousel) {
      this.$swiper.destroy(`.swiper.${this.swiperClass}`);
    }
  },
};
